module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Buy Crypto"},"zh":{"title":"购买加密货币"},"kr":{"title":"未找到"}}')
  delete Component.options._Ctor
}
